<template>
  <div>
    <v-toolbar color="highlight" dark flat dense class="sticky">
      <v-toolbar-title>{{$t('users')}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu transition="scale-transition" origin="right top" style="z-index: 10" class="white" :close-on-content-click="false" bottom left>
        <template v-slot:activator="{ on }">
          <v-btn color="white" icon v-on="on">
            <v-icon>fa-info-circle</v-icon>
          </v-btn>
        </template>
        <v-sheet flatwidth="600px">
          <v-list dense>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>{{$t('info_firelog_solutions')}}</v-list-item-content>
            </v-list-item>
          </v-list>
        </v-sheet>
      </v-menu>
      <!-- <v-toolbar-items> -->
      <can I="create" a="settings">
        <addInstaller :profiles="profiles" v-on:add-installer="addInstaller"></addInstaller>
      </can>
      <!-- </v-toolbar-items> -->
      <!-- <v-toolbar-items> -->
      <can I="update" a="settings">
        <v-btn
          class="ml-2"
          depressed
          small
          :disabled="!valid"
          color="primary"
          @click="update"
        >{{$t("save")}}</v-btn>
      </can>
      <!-- </v-toolbar-items> -->
    </v-toolbar>
    <v-container>
      <div v-if="usersGroupedByProfile && profiles" :disabled="!$can('update', 'installers')">
        <v-row>
          <v-col
            cols="sm"
            :sm="48 /(profiles.length + 1)"
            :md="24/(profiles.length + 1)"
            :lg="12 /(profiles.length + 1)"
            v-for="(profile,index) in profiles"
            :key="index"
          >
            <v-card
              width="100%"
              outlined
              class="pa-2"
              v-bind:class="usersGroupedByProfile[profile.Id].length > profile.Limit ? 'redborder': ''"
            >
              <v-subheader>{{$t(`${profile.Id}profile`)}}</v-subheader>
              <v-list width="100%" dense class="overflow-auto" max-height="700">
                <template v-if="usersGroupedByProfile[profile.Id]">
                  <draggable
                    :sort="false"
                    v-model="usersGroupedByProfile[profile.Id]"
                    :id="profile.Id"
                    :move="changeUserProfile"
                    :options="{group:'people'}"
                  >
                    <transition-group class="profile-list" tag="div" name="list">
                      <template v-for="item in usersGroupedByProfile[profile.Id]">
                        <div :key="item.Id">
                          <v-col cols="sm" sm="12">
                            <v-card
                              style="width: 100%"
                              class="white--text pa-1"
                              color="primary"
                              outined
                              label
                              pill
                            >
                              <v-card-title class="pa-1 body-2">
                                <v-icon color="white">person</v-icon>
                                <span>{{`${item.Firstname} ${item.Name}`}}</span>
                                <v-spacer></v-spacer>
                                <v-icon
                                  @click="selectUser(index, item)"
                                  v-if="index !== 0"
                                  small
                                  class="mr-2"
                                  color="white"
                                >fa-sliders-h</v-icon>
                                <can I="update" a="installersPassword">
                                  <editUser :user="item" />
                                </can>
                              </v-card-title>

                              <div>
                                <v-icon color="white">f</v-icon>
                                <small>{{item.Login}}</small>
                              </div>
                            </v-card>
                          </v-col>
                        </div>
                      </template>
                    </transition-group>
                  </draggable>
                </template>
              </v-list>
              <v-layout>
                <v-spacer></v-spacer>
                <p
                  v-bind:class="usersGroupedByProfile[profile.Id].length > profile.Limit ? 'error--text': ''"
                  class="overline"
                >{{`${usersGroupedByProfile[profile.Id].length}/${profile.Limit}`}}</p>
              </v-layout>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <userManager :selectedUser="selectedUser" v-on:close="dialog = false" :dialog="dialog"></userManager>
    </v-container>
    <savebeforeleave v-on:response="response" :dialog="saveDialog"></savebeforeleave>
  </div>
</template>


<script>
import uuid from "uuid";
import jwtdecode from "jwt-decode";
import profiles from "@/settings/settings.js";

import { serviceihub } from "@/services/service.ihub.js";
const _serviceIhub = new serviceihub();
import draggable from "vuedraggable";
import addInstaller from "@/components/pages/Users/AddUser";
import editUser from "@/components/pages/Users/EditUser";
import userManager from "@/components/pages/Users/UserManager";

export default {
  name: "Users",
  components: {
    draggable,
    addInstaller,
    editUser,
    userManager
  },
  beforeRouteLeave(to, from, next) {
    if (this.hasChanges) {
      if (this.$can("update", "installers")) {
        this.saveDialog = true;
        this.hasChanges = false;
        this.to = to;
        next(false);
      } else {
        next();
      }
    } else {
      next();
    }
  },
  data() {
    return {
      users: null,
      admins: null,
      readonlys: null,
      installers: null,
      hasChanges: false,
      saveDialog: false,
      profiles: null,
      noaccess: [],
      usersGroupedByProfile: [],
      valid: false,
      to: null,
      selectedUser: null,
      dialog: false
    };
  },
  methods: {
    selectUser(index, user) {
      if (index !== 0) {
        this.dialog = false;
        this.dialog = true;
        this.selectedUser = user;
      }
    },
    changeUserProfile(e, ev) {
      // console.log(e);
      // console.log("move event", e);

      let user = (e.draggedContext.element.ProfileId =
        e.relatedContext.component.$attrs.id);
      this.hasChanges = true;

      // console.log("usersgroupedbyprofile", this.usersGroupedByProfile);
    },

    response(answer) {
      if (answer) {
        this.update();
      }
      this.saveDialog = false;
      this.hasChanges = false;
      this.$router.push({
        name: this.to.name,
        params: this.to.params
      });
    },
    update() {
      if (this.valid) {
        let users = [];
        this.usersGroupedByProfile.forEach((profiles, key) => {
          profiles.forEach(element => {
            element.ProfileId = key;
            if (
              element.id != jwtdecode(localStorage.getItem("auth")).contactId
            ) {
              users.push(element);
            }
          });
        });
        // this.noaccess.forEach(element => {
        //   if (element.id != jwtdecode(localStorage.getItem("auth")).contactId) {
        //     users.push(element);
        //   }
        // });
        _serviceIhub
          .updateCustomerContacts(users)
          .then(res => {
            this.$noty.success('<i class="fas fa-check"></i>');
            this.saveDialog = false;
            this.hasChanges = false;

            this.$router.go();
          })
          .catch(error => {
            this.$noty.error(error);
          });
      } else {
        // this.$noty.warning(this.$t("error"));
      }
    },
    addInstaller(installer) {
      this.$http
        .addInstaller(installer)
        .then(res => {
          this.$noty.success('<i class="fas fa-check"></i>');
          this.$router.go();
        })
        .catch(error => {
          // this.$router.go();
          this.$noty.error(error);
        });
    }
  },
  watch: {
    profiles() {},
    validation() {},
    admins(n, o) {
      if (o != null && n != o) this.hasChanges = true;
    },
    readonlys(n, o) {
      if (o != null && n != o) this.hasChanges = true;
    },
    installers(n, o) {
      if (o != null && n != o) this.hasChanges = true;
    },
    usersGroupedByProfile(n, o) {
      this.valid = true;
      this.profiles.forEach(profile => {
        if (this.usersGroupedByProfile[profile.Id].length > profile.Limit) {
          this.valid = false;
        }
      });
      if (o != [] && n != o) this.hasChanges = true;
    }
  },
  created() {
    const customerId = jwtdecode(localStorage.getItem("auth")).customerId;
    _serviceIhub
      .getProfilesByCustomerId(customerId, profiles.firelogapplicationId)
      .then(res => {
        console.log("profiles", res.data);
        this.profiles = res.data;

        _serviceIhub
          .getCustomerContactXLicenseXProfilesByCustomerId(
            jwtdecode(localStorage.getItem("auth")).customerId,
            true,
            profiles.firelogapplicationId
          )
          .then(res => {
            console.log(res.data);

            this.users = res.data;
            this.noaccess = this.users.filter(
              x => x.ProfileId == profiles.noaccess
            );
            var distictProfileIds = [
              ...new Set(this.users.map(item => item.ProfileId))
            ];
            this.profiles.forEach(profile => {
              this.usersGroupedByProfile[profile.Id] = this.users.filter(
                x => x.ProfileId == profile.Id
              );
              this.$forceUpdate();
            });
            console.log(this.usersGroupedByProfile, "és");
            this.admins = this.users.filter(x => {
              return x.ProfileId == profiles.admin;
            });
            this.readonlys = this.users.filter(x => {
              return x.ProfileId == profiles.readonly;
            });
            this.installers = this.users.filter(x => {
              return x.ProfileId == profiles.installer;
            });
          })
          .catch(err => {
            console.log(err);
          });
      })
      .catch(err => {
        console.log(err);
      });
  }
};
</script>

<style scoped>
.profile-list {
  min-height: 80px;
}
.redborder {
  border-color: red !important;
}
</style>


// WEBPACK FOOTER //
// src/views/users/Index.vue